import React, { useState } from "react";
import { useRouter } from "next/router";
import styles from "./blog_search_box.module.scss";
import { FiSearch } from "react-icons/fi";

const BlogSearchBox = ({ loading }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const router = useRouter();
  const { key } = router.query;

  const submitHandler = (e) => {
    e.preventDefault();
    router.push({
      pathname: "/blog/search",
      query: `key=${searchTerm}&page=1`,
    });
    setSearchTerm("");
  };

  return (
    <div className={styles.blog_search_box}>
      <div className={styles.title}>Search</div>
      <div className="form_wrapper">
        <form onSubmit={submitHandler}>
          <div className={styles.input_wrapper}>
            {loading && <> loading </>}{" "}
            {!loading && (
              <FiSearch
                className={styles.search_icon}
                onClick={submitHandler}
              />
            )}
            <input
              onChange={(e) => setSearchTerm(e.target.value)}
              type="text"
              placeholder="Search..."
              value={searchTerm}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default BlogSearchBox;
